import direDawnIcon from "@assets/diredawn_icon.png";
import {srcUrl} from "@/api/ImageApi.ts";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";

export default function PlayerCampaignView({loading = false, error = false}: {loading?: boolean; error?: boolean}) {
    const {campaign} = useCampaign();
    return <div className="relative h-full w-full overflow-hidden bg-stone-950">
        <img src={srcUrl(campaign.image)} alt=""
            className="absolute inset-0 size-full object-cover blur-[1px]"/>
        <div className="absolute inset-0 bg-linear-to-b from-black/20 via-black/35 to-black/70"/>
        <div className="absolute left-5 bottom-5 flex max-w-[calc(100%-2.5rem)] gap-4">
            <img src={direDawnIcon} className="size-24 shrink-0 drop-shadow-2xl" alt="DireDawn"/>
            <div className="flex items-center min-w-0 text-right">
                <h1 className="text-3xl font-semibold text-white drop-shadow sm:text-5xl">{campaign.title}</h1>
                {loading && <p role="status" className="mt-3 text-sm text-white/70">Spieleransicht wird synchronisiert…</p>}
                {error && <p role="alert" className="mt-3 text-sm text-red-300">Die Spieleransicht konnte nicht synchronisiert werden.</p>}
            </div>
        </div>
    </div>;
}
